// extracted by mini-css-extract-plugin
export default {"aboutBlock":"About_aboutBlock__hEwUY","about":"About_about__iivJb"};